import { EnrolmentAccessStatus, TrialSummary } from "../types";

/**
 * The trial for this subject, or null when the user isn't trialling it.
 * Decided per subject: a user can trial one bank while holding paid access to others,
 * so the account-wide access status alone can't say whether a bank is trial-only.
 */
export function getSubjectTrial(
  trial: TrialSummary | null | undefined,
  accessStatus: EnrolmentAccessStatus | undefined,
  subjectId: string | number | null | undefined,
): { trial: TrialSummary; ended: boolean } | null {
  if (!trial || subjectId == null || String(trial.subjectId) !== String(subjectId)) {
    return null;
  }
  return { trial, ended: trial.ended || accessStatus === "expired" };
}
